<template>
  <v-card class="com-pc-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">色ごとの想定浸水深</span>
    </v-row>
    <v-col class="com-pc-card-contents legend pa-0">
      <v-img src="/kawabou/img/hanrei_hazard_object.png" class="bg-img">
      </v-img>
      <v-img
          src="/kawabou/img/hanrei_hazard_base.png"
          id="hazard_base"
        ></v-img>
    </v-col>
  </v-card>
</template>
<script>
export default {
  name: "iu-legend",
  data() {
    return {};
  },
  mounted() {
    this.changeOpacity();
  },
  computed: {
    /** 浸水想定図の透過率 */
    inundationOpacity: {
      get() {
        // 不透明度に反転して、パーセント指定を少数に変換して返す
        return (100 - this.$store.state.inundation.inundationOpacity) * 0.01;
      },
    },
  },
  watch: {
    inundationOpacity() {
      this.changeOpacity();
    },
  },
  methods: {
    changeOpacity() {
      var opacity = document.getElementById("hazard_base");
      opacity.style.opacity = this.inundationOpacity;
    },
  },
};
</script>

<style lang="scss" scoped>
.legend{
  width: 100%;
  height: 100%;
  position: relative;
  .bg-img{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
